import React from 'react';

export const LinkedInIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.51905 5.81429C7.51905 6.81629 6.70676 7.62858 5.70475 7.62858C4.70275 7.62858 3.89047 6.81629 3.89047 5.81429C3.89047 4.81228 4.70275 4 5.70475 4C6.70676 4 7.51905 4.81228 7.51905 5.81429Z"
      fill="#444D55"
    />
    <path
      d="M20.1097 19.9948H16.5908V14.3283C16.5908 12.9064 16.0845 11.9359 14.8061 11.9359C13.8314 11.9359 13.2534 12.5899 13.0002 13.2228C12.9074 13.4507 12.8821 13.7629 12.8821 14.0793V19.9948H9.35899C9.35899 19.9948 9.4054 10.4001 9.35899 9.40438H12.8821V10.9064C12.8821 10.9064 12.8652 10.9317 12.8568 10.9402H12.8821V10.9064C13.3504 10.1849 14.1858 9.15544 16.055 9.15544C18.3714 9.15544 20.1097 10.6702 20.1097 13.919V19.9948Z"
      fill="#444D55"
    />
    <path d="M7.40926 9.40969H3.89038V20.0001H7.40926V9.40969Z" fill="#444D55" />
  </svg>
);
